<!-- 集控器下设备管理 -->
<template>
    <div class='container containerBox'>
        <div class="device-left">
            <p class="content-title">设备列表</p>
            <ul class="device-list">
                <template v-for="(v, i) in deviceList">
                    <li :class="active === i ? 'active' : ''" :key="i" @click="handleChangeDev(v, i)">
                        <span>{{v.terminal_serial}}</span>
                    </li>
                </template>
            </ul>
        </div>
        <div class="device-opt">
            <div class="content-title handleForm">
                <span>设备参数</span>
                <div class="title-btn">
                    <div style="display: inline-block;width:120px;margin-right:10px;height:32px;">
                        <el-input v-model="var_Initial_addr" placeholder="请输入addr"></el-input>
                    </div>
					<el-button @click="deleteSome" type="primary" size="small">批量删除变量</el-button>
					<el-button @click="deleteAll" type="primary" size="small">删除全部变量</el-button>
                    <el-button @click="handleSearch" type="primary" size="small">查询</el-button>
                    <el-button @click="handleExport" type="primary" size="small">下载模板</el-button>
                    <el-upload
                        :action="UploadUrl" 
                        :show-file-list="false" 
                        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                        :on-success="handleAvatarSuccess" 
                        :on-progress="uploadVideoProcess"
                        :headers="headers"
                        name="image"
                        :before-upload="beforeAvatarUpload"
                        style="display: inline-block;">
                        <el-button size="small" type="primary" style="margin: 0 10px;">导入变量 <span v-if="videoUploadPercent>0 && videoUploadPercent<100">{{videoUploadPercent+"%"}}</span></el-button>
                    </el-upload>
                    <el-button @click="handleAdd" type="primary" size="small">新建参数</el-button>
                    <!-- <el-button @click="handleCopy" size="small">复制勾选参数</el-button> -->
					<el-button @click="handleSetConfigSome" type="warning" size="small">下发选中参数</el-button>
                    <el-button @click="handleSetConfig" type="warning" size="small">下发全部参数</el-button>
                </div>
            </div>
            <lb-table v-loading="loading"
                :column="tableData.column"
                :data="tableData.data"
                :height="maxHeight"
                :max-height="maxHeight"
                stripe
                pagination
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100]"
                :current-page.sync="page_num"
                :total="total"
                :page-size="page_sum"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @selection-change="handleSelectionChange">
            </lb-table>
        </div>

        <!-- 添加弹框 -->
        <cmp-opt-form-dialog :visible="visible" :form="itemData" @handleCloseDialog="handleCloseDialog"></cmp-opt-form-dialog>
    </div>
</template>

<script>
import Service from '@/api/Service'
import config from '@/config'
import Storage from '@/utils/storage'
import { $Alert, getMaxHeigth } from '@/utils/utils'
import LbTable from '@/components/lb-table/lb-table'
import cmpOptFormDialog from './cmpOptFormDialog'

export default {
    name:  'deviceList',
    data() {
        return {
            var_Initial_addr: '',

            deviceList: [],     // 设备列表
            active: 0,
            
            tableData: {
                column: [
                    {
                        type: 'selection',
                    },
                    {
                        prop: 'var_name',
                        label: '变量名称',
                        sortable: true,
                    },
                    {
                        prop: 'opcode',
                        label: '操作码',
                        render: (h, scope) => {
                            return (
                                <div>
                                    {this.fmtAddr(scope.row.opcode)}
                                </div>
                            )
                        }
                    },
                    {
                        prop: 'var_Initial_addr',
                        label: '变量地址',
                        sortable: true,
                    },
                    {
                        prop: 'var_type',
                        label: '数据类型',
                        render: (h, scope) => {
                            return (
                                <div>
                                    {this.fmtType(scope.row.var_type)}
                                </div>
                            )
                        }
                    },
                    {
                        prop: 'unit',
                        label: '单位名称'
                    },
                    {
                        prop: 'var_description',
                        label: '变量描述'
                    },
                    {
                        label: '操作',
                        width: '150',
                        render: (h, scope) => {
                            return (
                                <div>
                                    <el-button
                                        size="mini"
                                        onClick={ () => { this.handleEdit(scope.$index, scope.row) } }>编辑</el-button>
                                    <el-button
                                        size="mini"
                                        type="danger"
                                        onClick={ () => { this.handleDetele(scope.$index, scope.row) } }>删除</el-button>
                                </div>
                            )
                        }
                    },
                ],
                data: []
            },
            loading: false,
            multipleSelection: [],
            maxHeight: 500,
            loading: false,
            total: 0,
            page_num: 1,
            page_sum: 10,
			bjoid:"",

            // 弹框
            visible: false,
            itemData: {},

            linked_collector_id: '',

            // 上传
            UploadUrl: config.UPLOAD_URL,
            videoUploadPercent: 0,
        };
    },

    components: { LbTable, cmpOptFormDialog },

    computed: {
        headers() {
            let token = Storage.get('token');
            if (token) {
                return { Authorization: token.token };
            }else{
                return {}
            }
        }
    },

    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },

    created() {
        this.linked_collector_id = this.$route.params.gatewayId;
        this.getData();
    },

    methods: {
        async getData() {
            let oid = this.linked_collector_id
            let params = Object.assign({}, {page_num: 1,page_sum: 40,},{ oid });
            let res = await Service.getMeter(params);
            if(res) {
                let data = res.list === null ? [] : res.list;
                this.deviceList = data;
                if(data.length>0) this.getPlcConfig();
            }
        },
        async getPlcConfig() {
            let active = this.active
            let terminal_id = this.deviceList[active].oid;
			this.bjoid = terminal_id
            let { page_num, page_sum, var_Initial_addr } = this;
            let params = {
                terminal_id,
                page_num,
                page_sum,
                var_Initial_addr: var_Initial_addr === '' ? -1 : var_Initial_addr
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.tableData.data = list;
                this.total = res.total;
            }
        },
        handleSearch() {
            this.getPlcConfig()
        },
        // 切换设备
        handleChangeDev(v, i) {
			this.var_Initial_addr = "";
            this.active = i;
            this.getPlcConfig();
        },
        // 新增
        handleAdd() {
            this.visible = true;
            let active = this.active
            let terminal_id = this.deviceList[active].oid;
            this.itemData = {
                terminal_id,
            };
        },
        // 新增弹框
        handleCloseDialog(data) {
            this.visible = false;
            if(data.flag) {
                this.getPlcConfig();
            }
        },
        // 编辑
        handleEdit(index, row) {
            this.visible = true;
            this.itemData = row;
        },
		//批量删除
		deleteSome(){
			let oidlist = []
			for(var i=0;i<this.multipleSelection.length;i++){
				// oidlist.push(this.multipleSelection[i].oid)
				oidlist.push({oid:(this.multipleSelection[i].oid).toString()})
			}
            $Alert(`是否确认删除选中项？`).then( async (bool)=>{
                if(bool){
                    let res = await Service.delPlcConfigurationSome({oidlist:oidlist});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getPlcConfig();
                    }
                }
           });
		},
		// 删除全部变量
		deleteAll(){
            $Alert(`是否确认删除全部变量？`).then( async (bool)=>{
                if(bool){
                    let res = await Service.delPlcConfigurationAll({terminal_id:this.bjoid});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getPlcConfig();
                    }
                }
           });
		},
        // 删除
        handleDetele(index, row) {
            $Alert(`是否确认删除 ${row.var_name} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.delPlcConfiguration({oid: row.oid});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getPlcConfig();
                    }
                }
           });
        },
		//批量下发参数
        handleSetConfigSome() {
			let oidlist = []
			for(var i=0;i<this.multipleSelection.length;i++){
				// oidlist.push(this.multipleSelection[i].oid)
				oidlist.push({oid:(this.multipleSelection[i].oid).toString()})
			}
            $Alert(`确认后集控器会按照下方设置参数批量上报数据，是否确认操作？`).then( async (bool)=>{
                if(bool){
					let active = this.active
					let terminal_id = this.deviceList[active].oid;
                    let res = await Service.setPlcConfigurationSome({terminal_id:terminal_id,oidlist:oidlist});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
						this.getPlcConfig();
                    }
                }
           });
        },
        // 设置数据点表
        handleSetConfig() {
            $Alert(`确认后集控器会按照下方设置参数上报全部数据，是否确认操作？`).then( async (bool)=>{
                if(bool){
                    let active = this.active
                    let terminal_id = this.deviceList[active].oid;
					this.bjoid=terminal_id
                    let res = await Service.setPlcConfiguration({ terminal_id });
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                    }
                }
           });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleCopy() {
            console.log(this.multipleSelection)
        },
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getPlcConfig()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getPlcConfig()
        },
        fmtAddr(qrcode) {
            switch (qrcode) {
                case 1:
                    return "01"
                case 3:
                    return "03"
                case 5:
                    return "05"
                case 6:
                    return "06"
                default:
                    return ""
            }
        },
        fmtType(var_type) {
            switch (var_type) {
                case 1:
                    return "int16"
                case 2:
                    return "bool"
				case 3:
					return "int32"
				case 4:
					return "float"
				case 5:
					return "uint16"	
				case 6:
					return "uint32"		
            }
        },

        // 导出
        async handleExport() {
            location.href = "/导入变量模板.xlsx"
        },
        // 导入
        async handleAvatarSuccess(res) {
            if(res.status == 20001000) {
                let active = this.active
                let terminalid = this.deviceList[active].oid;
                let res1 = await Service.importPlcConfig({terminalid, file_path: res.data})
                if(res1) {
                    this.$message.success("操作成功");
                    this.page_num = 1
                    this.getPlcConfig()
                }
            }else{
                this.$message.error(res.message);
            }
        },
        uploadVideoProcess(event, file, fileList){
            this.videoUploadPercent = file.percentage.toFixed(0);
        },
        // 上传
        beforeAvatarUpload(file) {
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 2;
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if (!isLt2M) {
                this.$message.error("上传文件大小不能超过 2MB!");
            }
            return isLt2M;
        },
    }
}

</script>
<style lang='less' scoped>
    .container{
        .device-left{
            float: left;
            width: 200px;
            overflow-x: auto;
            background-color: #fff;
            .device-list{
                li{
                    padding: 0 8px;
                    position: relative;
                    line-height: 44px;
                    border-bottom: 1px solid #EBEEF5;
                    height: 44px;
                    font-size: 14px;
                    transition: all .2s;
                    cursor: pointer;
                    &:hover{
                        background-color: #fafafa;
                    }
                    &.active{
                        background-color: #f0f9eb;
                        span{
                            color: #009bac;
                        }
                    }
                    span{
                        color: #2c3e50;
                    }
                }
            }
        }
        .device-opt{
            margin-left: 210px;
        }
    }
</style>